import { useContext } from "react";
import { AuthContext } from "../AuthContext.js";
const useMe = ()=>{
    const context = useContext(AuthContext);
    if (void 0 === context) throw new Error('useMe must be used within an AuthProvider');
    return context.data;
};
const hooks_useMe = useMe;
export default hooks_useMe;
export { useMe };
